import {useContext} from "react";
import {SalepointContext} from "./SalepointsContext.tsx";

const useSalepoints = () => {
    const context = useContext(SalepointContext);
    return {allShops: context!.allShops, favoriteShop: context!.favoriteShop,
        cities: context!.cities, shopsByCity: context!.shopInCity, setPreferredCity: context!.setCity,
        preferredCity: context!.city, setFavoriteShop:context!.setFavoriteShop}
};
export default useSalepoints;
